module.exports = __webpack_public_path__ + "img/124.132ddd1a.png";